import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

// The back adds every activated planzone resource that isn't a member yet: the whole list is never loaded.
function createInteractor(repository: Repository): Interactor {
  return ({ project, role }) =>
    present(
      repository
        .saveEveryoneInProject(project, role)
        .then((projectResources) => ({
          resources: projectResources.map(({ resource }) => resource),
          project,
          role,
          projectResources,
        }))
        .catch(() => Promise.reject({ project, role })),
    );
}

export type { Interactor };

export { createInteractor };
